document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".slot-counter");

  // Save original numbers first
  counters.forEach(counter => {
    if (!counter.dataset.number) {
      const strong = counter.querySelector("strong");
      if (strong) {
        counter.dataset.number = strong.textContent.trim();
      } else {
        counter.dataset.number = "0";
      }
    }
  });

  function spinCounter(counter) {
    const finalNumber = counter.dataset.number;
    const digits = finalNumber.split("");

    // Clear existing content
    counter.innerHTML = "";

    // Build animated digits
    digits.forEach((digit) => {
      const strongSpan = document.createElement("strong");
      const span = document.createElement("span");
      span.className = "slot-digit";
      span.dataset.final = digit;
      span.textContent = Math.floor(Math.random() * 10);
      strongSpan.appendChild(span);
      counter.appendChild(strongSpan);
    });

    const duration = 800;
    const intervalSpeed = 50;

    const interval = setInterval(() => {
      counter.querySelectorAll(".slot-digit").forEach((digitSpan) => {
        if (digitSpan.dataset.final.match(/[0-9]/)) {
          digitSpan.textContent = Math.floor(Math.random() * 10);
        } else {
          digitSpan.textContent = digitSpan.dataset.final;
        }
      });
    }, intervalSpeed);

    setTimeout(() => {
      clearInterval(interval);
      counter.querySelectorAll(".slot-digit").forEach((digitSpan) => {
        digitSpan.textContent = digitSpan.dataset.final;
      });
    }, duration);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          spinCounter(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  counters.forEach((counter) => observer.observe(counter));
});

document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll("video.video1, video.video2");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;

      if (entry.isIntersecting) {
        video.play().catch(err => console.log("Autoplay blocked:", err));
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.5 });

  videos.forEach(video => observer.observe(video));
});

gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".button1, .box1-1, .box2-2, .box3-2, .grid-item img, .button2, .reason9, .reason-grid img, .button3, .table3").forEach((element) => {
  gsap.from(element, {
    opacity: 0,
    yPercent: 10,
    duration: 1,
    delay: 0,
    ease: "circ.inOut",
    scrollTrigger: {
      trigger: element,
      start: "top 90%",
      end: "top 30%",
      markers: false,
      toggleActions: "play none none none",
    },
  });
});